export const environment = {
    // apiHost: 'http://localhost:8080/saapi',
    // apiHost: 'http://13.235.28.241:8081/saapi'
    apiHost: 'http://advertisement.theshillongtimes.com:8080/saapi'
};
